import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { BrandsState } from '../../types';

import { addFavouriteBrands as addFavouriteBrandsOperation } from '../operations/addFavouriteBrands';

import { STATUS_LOADING } from 'common/constants';

export const addFavouriteStations = (builder: ActionReducerMapBuilder<BrandsState>) => builder
  .addCase(addFavouriteBrandsOperation.pending, (state) => {
    state.favouriteBrands.addingStatus = STATUS_LOADING.load;
  })
  .addCase(addFavouriteBrandsOperation.fulfilled, (state, { payload: { favouriteBrands } }) => {
    state.favouriteBrands.addingStatus = STATUS_LOADING.done;
    state.favouriteBrands.data = [...(state.favouriteBrands.data || []), ...favouriteBrands];
  })
  .addCase(addFavouriteBrandsOperation.rejected, (state) => {
    state.favouriteBrands.addingStatus = STATUS_LOADING.error;
  });
